import React from "react";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormField from "./FormField";

const BusinessDetailsStep = ({ formData, handleChange }) => {
  return (
    <Grid container spacing={3}>
      <Grid item size={12}>
        <Accordion
          defaultExpanded
          disableGutters
          sx={{
            borderRadius: "12px !important",
            border: "1px solid #D9E2EC",
            boxShadow: "none",
            "&:before": { display: "none" },
            mb: 1,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#64748B" }} />}>
            <Typography sx={{ fontWeight: 700, fontSize: "0.86rem", color: "#334155", fontFamily: '"exo", "Inter", sans-serif' }}>
              Basic business profile
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0 }}>
            <Grid container spacing={3}>
              <FormField
                label="Description (Optional)"
                name="description"
                value={formData.description}
                onChange={handleChange("description")}
                placeholder="Tell customers about your restaurant..."
                icon={<DescriptionOutlined sx={{ color: "#F9735B" }} />}
                multiline
                rows={3}
                gridSize={12}
              />

              <FormField
                label="Slogan (Optional)"
                name="slogan"
                value={formData.slogan}
                onChange={handleChange("slogan")}
                placeholder="Your tagline"
                gridSize={12}
              />

              <FormField
                label="Tax ID (Optional)"
                name="taxId"
                value={formData.taxId}
                onChange={handleChange("taxId")}
                placeholder="XX-XXXXXXX"
                gridSize={{ xs: 12, md: 6 }}
              />
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default BusinessDetailsStep;

